import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const addonsServices = {
  addNewSitePilotAddon,
  updatedSitePilotAddon,
  softDeleteRestoreSitePilotAddon,
  deleteSitePilotAddon,
  getSitePilotAddonList,
  getSingleSitePilotAddon
};

// Add New Addon
async function addNewSitePilotAddon(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewSitePilotAddon`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Addon
async function updatedSitePilotAddon(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedSitePilotAddon`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Addon
async function softDeleteRestoreSitePilotAddon(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreSitePilotAddon`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Addon
async function deleteSitePilotAddon(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteSitePilotAddon`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Addon
async function getSitePilotAddonList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSitePilotAddonList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSitePilotAddonList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Single Addon
async function getSingleSitePilotAddon(addonId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleSitePilotAddon/${addonId}`,
      headersWithAuthWithoutBody("GET", headers)
    )
  const data = await response.json();
  return data;
}